import { useEffect, useState } from "react";
import {
  getProductsFromCachedBasketCookie,
  ProductsInBasket,
} from "@~/utils/product.ts";
import { JL_EVENTS_ADD_TO_BASKET_SUCCESS } from "@~/utils/events";

const BASKET_QTY_UPDATED_EVENT = "jl-events.browser.basketQuantityUpdated";

export function useCachedBasketData(): ProductsInBasket {
  const [cachedBasketData, setCachedBasketData] = useState<ProductsInBasket>(
    [],
  );

  const updateCachedBasketData = () => {
    setCachedBasketData(getProductsFromCachedBasketCookie());
  };

  useEffect(function subscribeToBasketQuantityUpdates() {
    updateCachedBasketData();
    window.addEventListener(BASKET_QTY_UPDATED_EVENT, updateCachedBasketData);
    window.addEventListener(
      JL_EVENTS_ADD_TO_BASKET_SUCCESS,
      updateCachedBasketData,
    );

    return function unsubscribeFromBasketQuantityUpdates() {
      window.removeEventListener(
        BASKET_QTY_UPDATED_EVENT,
        updateCachedBasketData,
      );
      window.removeEventListener(
        JL_EVENTS_ADD_TO_BASKET_SUCCESS,
        updateCachedBasketData,
      );
    };
  }, []);

  return cachedBasketData;
}
